"use client";

import { useMutation } from "@tanstack/react-query";

import { useToast } from "@/components/ui/use-toast";

import { postDownloadProperties } from "@/services/properties";

import type { Uf } from "@/types";

export const usePostDownloadProperties = () => {
  const { toast } = useToast();

  return useMutation({
    mutationFn: ({ uf, email }: { uf: Uf["uf"]; email?: string }) =>
      postDownloadProperties(uf, email),
    onSuccess: async () => {
      toast({
        title:
          "Planilha baixada com sucesso! Verifique a sua área de downloads.",
        variant: "default",
      });
    },
    onError: (error) => {
      toast({
        title: "Erro ao baixar planilha",
        description:
          error instanceof Error
            ? error.message
            : "Ocorreu um erro ao baixar a planilha",
        variant: "destructive",
      });
    },
  });
};
